export const events = {
  openReportsDashboard: 'Go To Reports Dashboard',
  openCustomerReport: 'Go to Customer Report',
  downloadReportSuccess: 'Download Report Success',

  startReportFromLibrary: 'Add Report from Library Start',
  startReportFromGenerator: 'Add Report From Generator Start',
  startReportFromSql: 'Add SQL Report Start',
  startReportFromQuestion: 'Add Question Report Start',

  clickSaveWidgetFromBuilder: 'Send Widget From Builder to Dashboard',

  submitReportFromLibrary: 'Add Report From Library Submit',
  submitReportFromGenerator: 'Create Report From Generator Submit',
  submitReportFromSql: 'Create SQL Report Submit',
  submitReportFromQuestion: 'Create Question Report Submit',

  aggregationChanged: 'Aggregation changed',

  chartTypeSelected: 'Report chart type selected',
  dataSelected: 'Report data selected',
  xAxisSelected: 'Report x axis selected',
  yAxisSelected: 'Report y axis selected',
  groupBySelected: 'Group by selected',
  breakdownBySelected: 'Report breakdown by selected',

  clickReportShareFromWidget: 'Sharing click on share option on a widget',
  submitReportShare: 'Sharing submit the shares',
  clickReportShareAddNewPeople: 'Sharing opens the list of employees',
  ReportShareEmployeesSelected: 'Sharing add people employees selected',
  ReportShareVisibilitySelected: 'Sharing employee visibility of the share selected',
  ReportShareDeleteSelected: 'Sharing employee delete share',

  // Old events
  newReportFromClone: 'new report from clone',
  reportTemplatePreviewVisited: 'report template preview visited',
  timeoffReportVisited: 'TimeoffReportVisited',

  // Old events, also sending another newer event
  // submitReportFromSql
  newSqlReportSaved: 'new sql report saved',
  // reportsSqlEditVisited
  reportsSqlEditVisited: 'reports sql edit visited',
  // clickSaveWidgetFromBuilder
  newReportSavedButtonClicked: 'new report saved button clicked',
  // openReportsDashboard
  reportsDashboardVisited: 'reports dashboard visited',
  // openCustomerReport
  reportsEditVisited: 'reports edit visited',
  // submitReportFromGenerator
  newReportSaved: 'new report saved',
  // submitReportFromLibrary
  newReportFromTemplateSaved: 'new report from template saved',
  // submitReportFromQuestion
  newReportSavedFromAiQuestion: 'new report saved from an ai question',
}
